"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDepositLimit = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var user_1 = require("../user");
var useDepositLimit = function () {
    var _a, _b;
    var isAuth = (0, user_1.useIsAuthorized)();
    var _c = (0, useQuery_1.useQuery)({
        canRender: isAuth,
        path: keys_1.GET_DEPOSIT_LIMITS,
        revalidateOnMount: true,
    }), data = _c.data, isLoading = _c.isLoading, error = _c.error;
    return {
        data: (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b[0],
        isLoading: isLoading,
        error: error,
    };
};
exports.useDepositLimit = useDepositLimit;
